import React from "react";

export default function InstabilitySummary({ instabilities = [] }) {
    if (!instabilities || !instabilities.length) {
        return <span className="text-muted small italic p-2">No instabilities recorded</span>;
    }

    return (
        <div className="instability-summary-container p-1" style={{ minWidth: '180px' }}>
            <div className="fw-bold text-primary border-bottom mb-2 pb-1" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Recorded Instabilities
            </div>
            <div className="d-flex flex-column gap-1 mt-2">
                {instabilities.map((inst, index) => {
                    // inst can be a string or an object with a label
                    const label = typeof inst === 'string' ? inst : (inst.label || "Unknown");
                    const formatted = label.replace(/_/g, " ").replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

                    return (
                        <div key={index} className="badge bg-light text-dark border fw-medium text-start py-2 px-3" style={{ fontSize: '0.75rem', width: '100%' }}>
                            {formatted}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
